export default (el) => /^[object NodeList]$/.test(`${el}`);
